module.exports = __webpack_public_path__ + "img/application_icon_more_2x.d0352be9.png";